import { Center, Flex, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useState } from 'react';
import { TAgent, TAgentService, useAgentServices } from '@/models/agents';
import AddAgentService from './AddAgentService';
import AgentServiceEntry from './AgentServiceEntry';
import AgentServiceModal from './AgentServiceModal';

export function AgentServices({ agent }: { agent: TAgent }) {
  const { data: services = [] } = useAgentServices(agent.id);
  const [opened, { open, close }] = useDisclosure(false);
  const [selectedService, setSelectedService] = useState<TAgentService | null>(
    null,
  );

  const handleServiceClick = (service: TAgentService) => {
    setSelectedService(service);
    open();
  };

  const handleClose = () => {
    close();
  };

  return (
    <div>
      <Text size="xs" fw={500}>
        Agent Services
      </Text>
      {services.length > 0 ? (
        <>
          {services.map((service) => (
            <AgentServiceEntry
              key={service.id}
              service={service}
              onClick={() => handleServiceClick(service)}
            />
          ))}
        </>
      ) : (
        <Center>
          <Text size="xs" c="dimmed">
            No services found for this agent.
          </Text>
        </Center>
      )}
      <Flex justify={'flex-end'}>
        <AddAgentService agent={agent} />
      </Flex>

      {selectedService && (
        <AgentServiceModal
          service={selectedService}
          agentId={agent.id}
          opened={opened}
          onClose={handleClose}
        />
      )}
    </div>
  );
}
